import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { yonetim } from '../api';

function Kart({ etiket, deger, alt, vurgu, onClick }) {
  return (
    <div className={`stat-card${vurgu ? ' vurgu' : ''}`} style={onClick ? { cursor: 'pointer' } : undefined} onClick={onClick}>
      <div className="label">{etiket}</div>
      <div className="value">{deger ?? '-'}</div>
      {alt && <div className="sub">{alt}</div>}
    </div>
  );
}

export default function Pano() {
  const [ozet, setOzet] = useState(null);
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let iptal = false;
    yonetim
      .pano()
      .then((d) => { if (!iptal) setOzet(d); })
      .catch((e) => { if (!iptal) setHata(e.message); })
      .finally(() => { if (!iptal) setYukleniyor(false); });
    return () => { iptal = true; };
  }, []);

  return (
    <div>
      <div className="page-header">
        <h1>Pano</h1>
        <p>Bekleyen onaylar ve günlük özet</p>
      </div>

      {hata && <div className="mesaj hata">{hata}</div>}
      {yukleniyor && <div className="yukleniyor">Yükleniyor…</div>}

      {ozet && (
        <>
          <h3 style={{ margin: '4px 0 12px', fontSize: 15, color: '#555' }}>Bekleyen onaylar</h3>
          <div className="stats-grid">
            <Kart etiket="Bekleyen kuyumcu" deger={ozet.bekleyenKuyumcu} vurgu={ozet.bekleyenKuyumcu > 0}
              alt="Onaya git →" onClick={() => navigate('/kuyumcular')} />
            <Kart etiket="Bekleyen kampanya" deger={ozet.bekleyenKampanya} vurgu={ozet.bekleyenKampanya > 0}
              alt="Onaya git →" onClick={() => navigate('/kampanyalar')} />
            <Kart etiket="Bekleyen reklam" deger={ozet.bekleyenReklam} vurgu={ozet.bekleyenReklam > 0}
              alt="Onaya git →" onClick={() => navigate('/reklamlar')} />
          </div>

          <h3 style={{ margin: '12px 0 12px', fontSize: 15, color: '#555' }}>Bugün</h3>
          <div className="stats-grid">
            <Kart etiket="Bugünkü talep" deger={ozet.bugunkuTalep} />
            <Kart etiket="Bugünkü teklif" deger={ozet.bugunkuTeklif} />
            <Kart etiket="Bugünkü randevu" deger={ozet.bugunkuRandevu} />
          </div>

          <h3 style={{ margin: '12px 0 12px', fontSize: 15, color: '#555' }}>Kuyumcular</h3>
          <div className="stats-grid">
            <Kart etiket="Aktif kuyumcu" deger={ozet.aktifKuyumcu} />
            <Kart etiket="Üyeliği biten kuyumcu" deger={ozet.uyeligiBitenKuyumcu} />
          </div>
        </>
      )}
    </div>
  );
}
